import { createTypes } from "./createTypes";

export default createTypes("LOG_IN_USER", "UPLOAD_RESUME", "LOG_OUT_USER");
